import * as React from 'react'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import {faCheck} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Button from '@freckle/student-materials/src/components/button'
import {Container} from '@freckle/student-materials/src/components/container'
import {Modal} from '@freckle/student-materials/src/components/modal'
import {PATHS} from '@freckle/student-materials/src/helpers/paths'
import {SafeTrans, useSafeTranslation} from '@freckle/student-materials/src/helpers/translate'
import {plus, wrapper, btnWrapper, logo} from './star-integration-linked-modal.module.scss'

type Props = {
  show: boolean
  onHideModal: () => void
}

export function StarIntegrationLinkedModal(props: Props): React.ReactElement {
  const {show, onHideModal} = props
  const {t} = useSafeTranslation()

  const freckleLogo = 'company-logos/freckle-by-renaissance/colored_jt.png'
  const starLogo = 'student-web/star-integration/star-assessments-logo.svg'

  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHideModal}
      title={t('STAR_INTEGRATION_LINKED_MODAL_HEADER')}
    >
      <Container hideSlice>
        <div className={wrapper}>
          <img
            src={`${PATHS.imageAssetsUrl}/${freckleLogo}`}
            alt={t('STAR_INTEGRATION_LINKED_MODAL_FRECKLE_IMAGE_ALT')}
            title={t('STAR_INTEGRATION_LINKED_MODAL_FRECKLE_IMAGE_ALT')}
            className={logo}
          />
          <FontAwesomeIcon icon={faPlus} className={plus} />
          <img
            src={`${PATHS.imageAssetsUrl}/${starLogo}`}
            alt={t('STAR_INTEGRATION_LINKED_MODAL_STAR_MATH_IMAGE_ALT')}
            title={t('STAR_INTEGRATION_LINKED_MODAL_STAR_MATH_IMAGE_ALT')}
            className={logo}
          />
        </div>
      </Container>
      <div className={btnWrapper}>
        <Button onClick={onHideModal}>
          <SafeTrans
            i18nKey="STAR_INTEGRATION_LINKED_MODAL_BUTTON_TEXT"
            components={{checkIcon: <FontAwesomeIcon icon={faCheck} />}}
          />
        </Button>
      </div>
    </Modal>
  )
}
